/**
 * @file index.tsx
 *
 * @fileoverview Adds the FAQ structured data to the head of the document.
 */
import React from 'react';
import { FaqItem } from '~/jobiqo/types/types';
import { FAQPage } from 'schema-dts';
import { JsonLd } from 'react-schemaorg';

export interface SearchFaqProps {
  faqItems: FaqItem[];
}

export const SearchFaqSchema = ({ faqItems }: SearchFaqProps) => {
  return (
    <JsonLd<FAQPage>
      item={{
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqItems.map(({ question, answer }) => ({
          '@type': 'Question',
          name: question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: answer,
          },
        })),
      }}
    />
  );
};
